import { defineStore, storeToRefs } from 'pinia'
import { ref } from 'vue'
import { RequestService } from '../services/RequestService'
import { useEmployerStore } from './EmployerStore'
import { getFirestore, doc, updateDoc } from 'firebase/firestore'

export const useProfileStore = defineStore('profile', () => {
    const { handleErrors } = RequestService()
    let uid = null
    if (typeof window !== 'undefined' && window.localStorage) {
        uid = window.localStorage.getItem('userUid')
    }
    const employerStore = useEmployerStore()
    const { userData } = storeToRefs(employerStore)
    const showSuccessAlert = ref(false)
    const db = getFirestore()
    let userDocRef = null
    if (uid) {
      userDocRef = doc(db, 'users', uid)
    }

    function updateStore(data) {
        userData.value = {
            ...userData.value,
            ...data
        }
    }

    function showAlert() {
        showSuccessAlert.value = true
    }

    function hideAlert() {
        showSuccessAlert.value = false
    }

    async function updateUserData(data) {
        if (!userDocRef) {
          handleErrors('updateUserData', new Error('ProfileStore: updateUserData skipped, no valid userDocRef'))
          return
        }
        try {
            await updateDoc(userDocRef, {
                ...data
            })
            updateStore(data)
        } catch (error) {
            handleErrors('updateUserData', error)
        }
    }
  
    return {
        updateUserData,
        showAlert,
        hideAlert,
        showSuccessAlert
    }
})
